import { Button, Col, Form, Row } from "antd";
import { LoginOutlined } from "@ant-design/icons";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  getMyPermissions, requestAdminLogin, setAdminToken, setUserProfile } from "../../core/store/reducers/auth.slice";
import LoginLayout from "../../shared/layouts/login.layout";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { RootState } from "../../shared/types/common";
import { loginRequest } from "../../msalConfig";

const LoginPage: React.FC = () => {
  return <LoginLayout loginForm={<LoginForm />}></LoginLayout>;
};
export default LoginPage;

const LoginForm: React.FC = () => {
  const { accessToken } = useSelector(
    (state: RootState) => state.auth
  );
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Handle redirect response after login
    if (accounts?.length > 0 && accessToken && isAuthenticated ) return;
    instance
      .handleRedirectPromise()
      .then((response) => {
        if (response) {
          setLoading(true);
          // console.log(response);
          dispatch(requestAdminLogin({ token: response?.idToken }))
            .then(async (res: any) => {
              await new Promise((resolve) => setTimeout(resolve, 1000));
              if (res?.payload?.data?.data?.access_token) {
                await dispatch(
                  setAdminToken(res?.payload?.data?.data?.access_token)
                  
                );
                await dispatch(
                  
                  setUserProfile(res?.payload?.data?.data?.user)
                );
                await dispatch(getMyPermissions())
                // const response = await dispatch(getAdminProfile()).unwrap();
                // const roleId = response?.data?.data?.role_id;

              } else {
                sessionStorage.clear();
                // notification.error({ message: t("LOGIN.LOGIN_ERROR") })
              }
              setLoading(false);
            })
            .catch((error: any) => {
              console.log(error);
              setLoading(false);
            });
        }
      })
      .catch((error) => console.log(error));
  }, [instance, accounts]);

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((error) => {
      console.log(error);
    });
  };

  const onValuesChange = (_e: any) => {};
  return (
    <div className="login-page login-page--with-bg-image">
      <Row justify="center" align="middle" className="h-100" style={{ width: "100%" }}>
        <Col xs={22} sm={20} md={14} lg={11} xl={9} className="login-page__inner">
          <div className="login-page__card">
            <div className="login-page__logo-wrap">
              <img
                src="/assets/images/robotico-logo.svg"
                alt="Robotico Digital"
                className="login-page__logo"
              />
            </div>
            <h1 className="login-page__title">Welcome back</h1>
            <p className="login-page__subtitle">
              Sign in with your Microsoft account to access Resource Planner.
            </p>
            <Form
              name="normal_login"
              className="login-page__form"
              layout="vertical"
              onFinish={handleLogin}
              initialValues={{}}
              onValuesChange={onValuesChange}
            >
              <Row align="middle">
                <Col span={24}>
                  <Form.Item>
                    <Button
                      loading={loading || isAuthenticated || accounts?.length > 0}
                      type="primary"
                      block
                      htmlType="submit"
                      size="large"
                      icon={<LoginOutlined />}
                    >
                      Sign in with Microsoft
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <div className="login-page__footer">
              &copy; {moment().format("YYYY")} Robotico Digital LLP
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

